import { Injectable } from '@angular/core';
import { BaseAppStateService } from '@modules/common/services/base-app-state.service';
import { Application } from '@modules/common/types/application';
import { type Observable, of } from 'rxjs';
import { type FormFolderStitch, type FormStitch } from '../types/form-stitch';

/** Supplies the native list-state context without sharing another app's saved state. */
@Injectable()
export class FormsKpAppStateService extends BaseAppStateService<
  FormFolderStitch,
  FormStitch,
  'all_forms' | 'search_results'
> {
  protected readonly application = Application.forms;
  protected readonly defaultVirtualFolder = 'all_forms' as const;
  public readonly searchResultsFolder = 'search_results' as const;

  public getTabs(): Observable<string> {
    return of('forms');
  }
}
